/**
 * sz-2610-ty-shared-bg
 * Single marker section: stretch background across the next N sibling sections.
 * Stops early if another shared-bg section is reached. Multiple groups OK.
 */
(function () {
  'use strict';

  if (window.__sz2610TySbgBooted) {
    if (typeof window.sz2610TySharedBgRefresh === 'function') {
      window.sz2610TySharedBgRefresh();
    }
    return;
  }
  window.__sz2610TySbgBooted = true;

  var ATTR_ROOT = 'data-sz-2610-ty-sbg';
  var ATTR_LAYER = 'data-sz-2610-ty-sbg-layer';
  var CLASS_IN_RANGE = 'sz-2610-ty-sbg-in-range';
  var CLASS_CLEAR = 'sz-2610-ty-sbg-in-range--clear';
  var rafId = 0;
  var resizeObserver = null;
  var middleMap = new WeakMap();

  function shopifySectionOf(el) {
    if (!el) return null;
    return el.closest ? el.closest('.shopify-section') : null;
  }

  function isSharedBgSection(sectionEl) {
    return !!(sectionEl && sectionEl.querySelector && sectionEl.querySelector('[' + ATTR_ROOT + ']'));
  }

  function findRange(rootEl) {
    var hostSection = shopifySectionOf(rootEl);
    if (!hostSection) {
      return { hostSection: null, middles: [], endSection: null };
    }

    var coverCount = parseInt(rootEl.getAttribute('data-cover-count') || '2', 10);
    if (isNaN(coverCount) || coverCount < 1) coverCount = 1;
    if (coverCount > 20) coverCount = 20;

    var middles = [];
    var el = hostSection.nextElementSibling;

    while (el && middles.length < coverCount) {
      if (isSharedBgSection(el)) {
        break;
      }
      middles.push(el);
      el = el.nextElementSibling;
    }

    var endSection = middles.length ? middles[middles.length - 1] : null;
    return { hostSection: hostSection, middles: middles, endSection: endSection };
  }

  function clearRangeClasses(rootEl) {
    var prev = middleMap.get(rootEl);
    if (!prev || !prev.length) return;
    for (var i = 0; i < prev.length; i++) {
      prev[i].classList.remove(CLASS_IN_RANGE, CLASS_CLEAR);
      prev[i].style.removeProperty('position');
      prev[i].style.removeProperty('z-index');
    }
    middleMap.delete(rootEl);
  }

  function layoutOne(rootEl) {
    var layer = rootEl.querySelector('[' + ATTR_LAYER + ']');
    if (!layer) return null;

    var range = findRange(rootEl);
    clearRangeClasses(rootEl);

    if (!range.hostSection || !range.endSection) {
      layer.style.height = '0px';
      rootEl.setAttribute('data-sz-sbg-active', 'false');
      return null;
    }

    rootEl.setAttribute('data-sz-sbg-active', 'true');
    rootEl.setAttribute('data-sz-sbg-covered', String(range.middles.length));

    var hostRect = range.hostSection.getBoundingClientRect();
    var endRect = range.endSection.getBoundingClientRect();
    var top = hostRect.top + window.scrollY;
    var bottom = endRect.bottom + window.scrollY;
    var height = Math.max(0, Math.round(bottom - top));

    layer.style.height = height + 'px';

    var contentZ = rootEl.getAttribute('data-content-z') || '1';
    var forceClear = rootEl.getAttribute('data-force-transparent') !== 'false';

    for (var i = 0; i < range.middles.length; i++) {
      var mid = range.middles[i];
      mid.classList.add(CLASS_IN_RANGE);
      if (forceClear) mid.classList.add(CLASS_CLEAR);
      mid.style.position = 'relative';
      mid.style.zIndex = contentZ;
    }

    middleMap.set(rootEl, range.middles);
    return range;
  }

  function ensureObserver() {
    if (typeof ResizeObserver === 'undefined') return null;
    if (resizeObserver) return resizeObserver;
    resizeObserver = new ResizeObserver(function () {
      scheduleLayout();
    });
    return resizeObserver;
  }

  function reobserveAll(ranges) {
    var ro = ensureObserver();
    if (!ro) return;
    ro.disconnect();
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      if (!range) continue;
      if (range.hostSection) ro.observe(range.hostSection);
      for (var j = 0; j < range.middles.length; j++) {
        ro.observe(range.middles[j]);
      }
    }
  }

  function layoutAll() {
    var roots = document.querySelectorAll('[' + ATTR_ROOT + ']');
    var ranges = [];
    for (var i = 0; i < roots.length; i++) {
      ranges.push(layoutOne(roots[i]));
    }
    reobserveAll(ranges);
  }

  function scheduleLayout() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      layoutAll();
    });
  }

  function init() {
    layoutAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', scheduleLayout);
  window.addEventListener('load', scheduleLayout);

  document.addEventListener('shopify:section:load', scheduleLayout);
  document.addEventListener('shopify:section:unload', scheduleLayout);
  document.addEventListener('shopify:section:reorder', scheduleLayout);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleLayout).catch(function () {});
  }

  window.sz2610TySharedBgRefresh = scheduleLayout;
})();
